import React, { useState } from 'react';
import { DatePicker, Form, Table, Spin, Empty } from "antd";
import moment from "moment";
import { ReactComponent as CalendarIcon } from "../../../assets/icons/calendar-icon.svg";
import { getRequest } from "../../../http/axiosConfig/config";
import urls from "../../../http/endpoints/urls";
import { DownloadOutlined } from "@ant-design/icons";
import { generateTransactionDetailPDF } from "./TransactionDetailReport";

export default function TransactionDetail() {
  const [dateForm] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [transactions, setTransactions] = useState(null);
  const [showDownload, setShowDownload] = useState(false);
  let customer_code = localStorage.getItem("userId");

  const disabledDate = (current) => {
    return (
      current && current < moment("2026-04-01", "YYYY-MM-DD").startOf("day")
    );
  };

  const getTransactionData = async (values) => {
    try {
      setLoading(true);
      let date = values.date.format("DD-MM-YYYY");
      const res = await getRequest(
        urls.getTransactionDetails(date, customer_code),
      );
      setTransactions(res);
      setShowDownload(true);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const columns = [
    {
      title: <div style={{ fontSize: "9px", whiteSpace: "nowrap" }}>Time</div>,
      dataIndex: "TIME",
      width: 20,
      align: "center",
      render: (text) => <div style={{ fontSize: "9px", whiteSpace: "nowrap" }}>{text}</div>,
    },
    {
      title: <div style={{ fontSize: "9px", whiteSpace: "nowrap" }}>Amount</div>,
      dataIndex: "AMOUNT",
      width: 20,
      align: "center",
      render: (text) => <div style={{ fontSize: "9px", whiteSpace: "nowrap" }}>{text}</div>,
    },
    {
      title: <div style={{ fontSize: "9px", whiteSpace: "nowrap" }}>Status</div>,
      dataIndex: "STATUS",
      width: 30,
      align: "center",
      render: (text) => (
        <div style={{ 
          fontSize: "9px", 
          whiteSpace: "nowrap", 
          color: text === 'SUCCESS' ? 'green' : text === 'FAILED' ? 'red' : 'inherit',
          fontWeight: 'bold'
        }}>
          {text}
        </div>
      ),
    },
    {
      title: <div style={{ fontSize: "9px", whiteSpace: "nowrap" }}>Payment ID</div>,
      dataIndex: "PAYMENT_ID",
      width: 30,
      align: "center",
      render: (text) => <div style={{ fontSize: "9px", whiteSpace: "nowrap" }}>{text}</div>,
    },
    {
      title: <div style={{ fontSize: "9px", whiteSpace: "nowrap" }}>Bank Ref. No.</div>,
      dataIndex: "BANK_REF_NO",
      width: 30,
      align: "center",
      render: (text) => <div style={{ fontSize: "9px", whiteSpace: "nowrap" }}>{text}</div>,
    },
    {
      title: <div style={{ fontSize: "9px", whiteSpace: "nowrap" }}>Mode</div>,
      dataIndex: "PAYMENT_MODE",
      width: 30,
      align: "center",
      render: (text) => <div style={{ fontSize: "9px", whiteSpace: "nowrap" }}>{text}</div>,
    },
  ];

  return (
    <div>
      <div className="page-header">
        Transaction Detail
      </div>
      <Form
        className="date-range-form"
        form={dateForm}
        layout={"horizontal"}
        onFinish={getTransactionData}
        requiredMark={false}
        onValuesChange={() => setShowDownload(false)}
        style={{
          marginTop: 10,
          marginBottom: 10,
          display: "flex",
          alignItems: "center",
          gap: 2,
        }}
      >
        <Form.Item
          noStyle
          name={"date"}
          rules={[{ required: true, message: "Please select date" }]}
        >
          <DatePicker
            style={{ width: 250 }}
            suffixIcon={<CalendarIcon />}
            format="DD/MM/YY"
            disabledDate={disabledDate}
          />
        </Form.Item>
        <Form.Item noStyle>
          <button
            style={{
              width: 60,
              padding: 7,
              backgroundColor: "#1890ff",
              color: "#fff",
              border: "none",
              borderRadius: 8,
              cursor: "pointer",
              marginLeft: 8,
              boxShadow: "none",
            }}
            onClick={() => dateForm.submit()}
          >
            Go
          </button>
        </Form.Item>
        {showDownload && transactions && transactions.length > 0 && !loading && (
          <Form.Item noStyle>
            <DownloadOutlined
              style={{
                fontSize: 24,
                cursor: "pointer",
                color: "#1890ff",
                marginLeft: 10,
              }}
              onClick={() => {
                const date = dateForm.getFieldValue("date").format("DD/MM/YYYY");
                generateTransactionDetailPDF(transactions, date);
              }}
              title="Download Transaction Detail PDF"
            />
          </Form.Item>
        )}
      </Form>

      {!loading && transactions ? (
        <>
          <Table
            dataSource={loading ? [] : transactions}
            locale={{
              emptyText: loading ? <Spin /> : <Empty />,
            }}
            columns={columns}
            bordered
            size="small"
            scroll={{ y: "calc(100vh - 250px)", x: 600 }}
            pagination={false}
          />
        </>
      ) : null}
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Spin />
        </div>
      ) : null}
    </div>
  )
}
